














import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { ChartsViewModel, ChartsService } from '../../api/charts';

@Component({})
export default class ChartsEdit extends Vue {
  private service: ChartsService = new ChartsService();
  private data: ChartsViewModel = this.service.NewModel;
  private rules = {
    name: [{required: true, message: '请输入关系图名称', trigger: 'blur'}],
  };

  @Emit('OnSave')
  private OnSave(isCreate: boolean) {
    return isCreate;
  }
  private btnSave_OnClick() {
    const validate = this.$refs.editForm as any;
    validate.validate((valid: any) => {
      if (valid) {
        this.service.Create(this.data).then((response: any) => {
          this.$message.success('保存成功');
          this.OnSave(true);
        });
      }
    });
  }
}
